import { InjectionToken } from '@angular/core';

export const FIREBASE_CONFIG = new InjectionToken<any>('Firebase configuration');
